/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Class of Services)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for Class of Services forms.
────────────────────────────────────────────────────────────────*/

import { FormState } from '../types';

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  description: '',
  featureCodeCosId: null,
  dialRuleRestrictionId: null,
  arsId: null,
  isMain: false,
  enabled: true,
  failoverDestinationModule: 'terminate',
  failoverDestinationData: null,
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return JSON.parse(JSON.stringify(DEFAULT_FORM_STATE));
}

